// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.esbFilterResults__filter {
    margin: 10px 10px 10px 0px;
    padding: 2px;
    min-width: 150px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    word-break: normal;
    background-color: #efefef;
    border-radius: 5px;
}

.esbFilterResults__removeButton:before,
.esbFilterResults__removeButton {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\\F00D";
    border-style: none;
    color: black;
    background-color: transparent;
    font-size: 18px;
    margin-left: 5px;
}

.esbFilterResults__group {
    margin-left: 5px;
}

.esbFilterResults__label {
    margin-left: 5px;
}

@media (min-width: 620px) {
    .esbFilterResults__filter {
        min-width: 100px;
    }
}


/* --- MultiSearch css --- */

.selectize-control.multi .selectize-input > button.item {
    padding: 2px 6px !important; /* important needed because of important from commons */
}

.selectize-control.multi .selectize-input>button {
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 3px 3px 0;
    padding: 1px 3px;
    background: #efefef;
    color: #333333;
    border: 0 solid rgba(0,0,0,0);
}

div .selectize-control.multi .selectize-input .group {
    padding-right: 8px;
}

div .selectize-control.multi .selectize-input .fa-times {
    padding-left: 8px;
}

.esbSearchError,
.esbSearchError.active {
    border-width: 0;
    color: red;
    background: white;
}

.esbSearchErrorPresent .esbSearchError {
    margin-top: 5px;
}

.esbSearchErrorNotPresent .esbSearchError {
    display: none;
}

/* --- Pagination not visible per default --- */

.multiplePages .entryPaginationFiller {
    display: none !important;
}

/* --- Facet css --- */
.entryscape .esbFacets__collection h3 {
    /* width: 100%; */
    /* padding: 5px 10px 0px; */
    border-bottom: 1px solid #c4c4c4;
    margin: 20px 5px 5px;
    padding-bottom: 5px;
}

.entryscape .esbFacets__collection ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.entryscape .esbFacets__collection li {
    line-height: 27px;
    display: block;
    padding: 2px 33px 2px 10px;
    cursor: pointer;
    position: relative;
}
.entryscape .esbFacets__optionLink {
    width: 100%;
    height: 100%;
    display: block;
    color: inherit;
}

.entryscape .esbFacets__option.esbFacets--selected {
    background: #f7f7f7;
    cursor: default;
}

.entryscape .esbFacets__option:hover {
    background: #f7f7f7;
    color: #005a9c;
}

.entryscape .esbFacets__clear {
    position: absolute;
    margin-right: 10px;
    top: 0px;
    right: 0px;
    padding: 4px 10px;
}

.entryscape .esbFacets__clear:focus {
    border: 1px solid blue;
    color: #005a9c;
}

.entryscape .esbFacets__occurence {
    margin-left: 6px;
}

.esbFacets__limit {
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
}

.entryscape .facetLabel {
    word-break: normal;
    overflow-wrap: break-word;
}

/* sort and limit*/
.esbSort input[type="select-one"], .esbLimit input[type="select-one"] {
    caret-color: transparent;
}

/* searchFilter */
.selectize-control.single {
    margin-bottom: 7px; /* adjust to match previous version */
}

/* radio buttons */
.esbRadioOption input.esbRadioButton {
    margin-right: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/search/search.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;;AAGA,4BAA4B;;AAE5B;IACI,2BAA2B,EAAE,uDAAuD;AACxF;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,+CAA+C;;AAE/C;IACI,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,kBAAkB,EAAE,qCAAqC;AAC7D;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;AACrB","sourcesContent":[".esbFilterResults__filter {\n    margin: 10px 10px 10px 0px;\n    padding: 2px;\n    min-width: 150px;\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    word-break: normal;\n    background-color: #efefef;\n    border-radius: 5px;\n}\n\n.esbFilterResults__removeButton:before,\n.esbFilterResults__removeButton {\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    content: \"\\F00D\";\n    border-style: none;\n    color: black;\n    background-color: transparent;\n    font-size: 18px;\n    margin-left: 5px;\n}\n\n.esbFilterResults__group {\n    margin-left: 5px;\n}\n\n.esbFilterResults__label {\n    margin-left: 5px;\n}\n\n@media (min-width: 620px) {\n    .esbFilterResults__filter {\n        min-width: 100px;\n    }\n}\n\n\n/* --- MultiSearch css --- */\n\n.selectize-control.multi .selectize-input > button.item {\n    padding: 2px 6px !important; /* important needed because of important from commons */\n}\n\n.selectize-control.multi .selectize-input>button {\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    cursor: pointer;\n    margin: 0 3px 3px 0;\n    padding: 1px 3px;\n    background: #efefef;\n    color: #333333;\n    border: 0 solid rgba(0,0,0,0);\n}\n\ndiv .selectize-control.multi .selectize-input .group {\n    padding-right: 8px;\n}\n\ndiv .selectize-control.multi .selectize-input .fa-times {\n    padding-left: 8px;\n}\n\n.esbSearchError,\n.esbSearchError.active {\n    border-width: 0;\n    color: red;\n    background: white;\n}\n\n.esbSearchErrorPresent .esbSearchError {\n    margin-top: 5px;\n}\n\n.esbSearchErrorNotPresent .esbSearchError {\n    display: none;\n}\n\n/* --- Pagination not visible per default --- */\n\n.multiplePages .entryPaginationFiller {\n    display: none !important;\n}\n\n/* --- Facet css --- */\n.entryscape .esbFacets__collection h3 {\n    /* width: 100%; */\n    /* padding: 5px 10px 0px; */\n    border-bottom: 1px solid #c4c4c4;\n    margin: 20px 5px 5px;\n    padding-bottom: 5px;\n}\n\n.entryscape .esbFacets__collection ul {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.entryscape .esbFacets__collection li {\n    line-height: 27px;\n    display: block;\n    padding: 2px 33px 2px 10px;\n    cursor: pointer;\n    position: relative;\n}\n.entryscape .esbFacets__optionLink {\n    width: 100%;\n    height: 100%;\n    display: block;\n    color: inherit;\n}\n\n.entryscape .esbFacets__option.esbFacets--selected {\n    background: #f7f7f7;\n    cursor: default;\n}\n\n.entryscape .esbFacets__option:hover {\n    background: #f7f7f7;\n    color: #005a9c;\n}\n\n.entryscape .esbFacets__clear {\n    position: absolute;\n    margin-right: 10px;\n    top: 0px;\n    right: 0px;\n    padding: 4px 10px;\n}\n\n.entryscape .esbFacets__clear:focus {\n    border: 1px solid blue;\n    color: #005a9c;\n}\n\n.entryscape .esbFacets__occurence {\n    margin-left: 6px;\n}\n\n.esbFacets__limit {\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 10px;\n}\n\n.entryscape .facetLabel {\n    word-break: normal;\n    overflow-wrap: break-word;\n}\n\n/* sort and limit*/\n.esbSort input[type=\"select-one\"], .esbLimit input[type=\"select-one\"] {\n    caret-color: transparent;\n}\n\n/* searchFilter */\n.selectize-control.single {\n    margin-bottom: 7px; /* adjust to match previous version */\n}\n\n/* radio buttons */\n.esbRadioOption input.esbRadioButton {\n    margin-right: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
